import { Routes, Route, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './App.css';
import TermsClient from './pages/TermsClient';
import TermsPro from './pages/TermsPro';
import PrivacyClient from './pages/PrivacyClient';
import PrivacyPro from './pages/PrivacyPro';

function Home() {
  return (
    <div className="app">
      {/* Hero Section */}
      <main className="hero">
        <motion.div
          className="logo-container"
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <img
            src="/logoApp.png"
            alt="RideLuv"
            className="logo"
          />
        </motion.div>

        <motion.h1
          className="hero-title"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
        >
          RideLuv
        </motion.h1>

        <motion.p
          className="hero-subtitle"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
        >
          <strong>Meet the vibes. Feel the vibes. Ride the vibes.</strong>
        </motion.p>

        <motion.div
          className="store-buttons"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6, ease: "easeOut" }}
        >
          <motion.a
            href="https://apps.apple.com/app/rideluv"
            target="_blank"
            rel="noopener noreferrer"
            className="store-button app-store"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <img src="/appstore.png" alt="Télécharger sur l'App Store" />
          </motion.a>

          <motion.a
            href="https://play.google.com/store/apps/details?id=com.rideluv"
            target="_blank"
            rel="noopener noreferrer"
            className="store-button google-play"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <img src="/googleplay.png" alt="Disponible sur Google Play" />
          </motion.a>
        </motion.div>
      </main>

      {/* Footer */}
      <motion.footer
        className="footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.8 }}
      >
        <div className="footer-content">
          <p className="footer-brand">RideLuv</p>
          <p className="footer-text"><strong>Meet the vibes. Feel the vibes. Ride the vibes.</strong></p>

          <nav className="footer-links">
            <Link to="/privacy" className="footer-link">Confidentialité</Link>
            <Link to="/terms" className="footer-link">Conditions d'utilisation</Link>
            <a href="mailto:contact@rideluv.com" className="footer-link">Contact</a>
          </nav>

          <p className="footer-copyright">
            © {new Date().getFullYear()} RideLuv. Tous droits réservés.
          </p>
        </div>
      </motion.footer>
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/terms" element={<TermsClient />} />
      <Route path="/terms-pro" element={<TermsPro />} />
      <Route path="/privacy" element={<PrivacyClient />} />
      <Route path="/privacy-pro" element={<PrivacyPro />} />
    </Routes>
  );
}

export default App;
